// src/components/MetaLoader.js
import React, {useEffect, useState} from 'react';
import {Helmet} from 'react-helmet-async';
import {fetchDateActivityInfo} from "../api/dateActivityInfoApi";

const MetaLoader = () => {
    const [metaData, setMetaData] = useState({
        name: 'description',
        content: ''
    });

    useEffect(() => {
        fetchDateActivityInfo().then(data => {
            setMetaData({
                name: 'description',
                content: data.contentTxt
            });
        }).catch(error => {
            console.error("Error fetching title data:", error);
        });
    }, []);

    return (
        <Helmet>
            <meta name={metaData.name} content={metaData.content}/>
        </Helmet>
    );
};

export default MetaLoader;
